import clsx from 'clsx';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { CheckboxCheckedIcon } from '~components/icons/CheckboxCheckedIcon';
import { CheckboxUncheckedIcon } from '~components/icons/CheckboxUncheckedIcon';
import { Button } from '~modules/media-library/view/Button';

export const CheckboxButton = forwardRef<
  ComponentRef<typeof Button>,
  Omit<ComponentPropsWithoutRef<typeof Button>, 'variant'> & {
    isChecked?: boolean;
    focus?: boolean;
  }
>(function CheckboxButton({ children, isChecked = false, focus = false, className = '', ...ButtonProps }, ref) {
  return (
    <Button
      variant="ghost"
      className={clsx('ml--checkbox', focus && 'underline', className)}
      {...ButtonProps}
      ref={ref}
    >
      {isChecked ? (
        <CheckboxCheckedIcon className="w-5 h-5 mr-1" />
      ) : (
        <CheckboxUncheckedIcon className="w-5 h-5 mr-1" />
      )}
      {children}
    </Button>
  );
});
